import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({ selector: 'app-overlay-custom-code-dialog', styleUrls: ['../billing-dialog.scss'], template: `
  <h2 mat-dialog-title>Add custom Bundle code</h2>
  <mat-dialog-content>
    <p>The code is saved with this report. Overlay cost comparisons use the partner tier and configured Data Overages prices. No Bill remains non-billable.</p>
    <mat-form-field appearance="outline">
      <mat-label>Custom code</mat-label>
      <input matInput [formControl]="code" maxlength="64" (input)="normalize($event.target.value)" cdkFocusInitial>
      <mat-hint>Letters, numbers, underscores, and hyphens; up to 64 characters.</mat-hint>
      <mat-error>Enter a valid code. CONFLICT and YES are reserved.</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end"><button mat-button (click)="ref.close()">Cancel</button><button mat-raised-button color="primary" [disabled]="code.invalid" (click)="ref.close(code.value)">Use code</button></mat-dialog-actions>
`, styles: ['mat-form-field { width: 100%; } p { font-size: 13px; line-height: 1.5; }'] })
export class OverlayCustomCodeDialogComponent {
  readonly code = new FormControl('', [Validators.required, Validators.pattern(/^[A-Z0-9][A-Z0-9_-]{0,63}$/),
    control => ['CONFLICT', 'YES'].includes(control.value) ? { reserved: true } : null]);
  constructor(public ref: MatDialogRef<OverlayCustomCodeDialogComponent>) { }
  normalize(value: string): void { this.code.setValue(value.trim().toUpperCase(), { emitEvent: false }); }
}
